export const SHOW_CART_TOAST = 'SHOW_CART_TOAST';
export const HIDE_CART_TOAST = 'HIDE_CART_TOAST';
